<template>
  <ion-page>
  <master-layout pageTitle="گزارشات">
    <ion-card-content>
      <Loading :is="!pageLoaded" v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
        <div v-if="items">
          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <router-link :to="'/Customer/list'" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-users"></i>
                  <div>تعداد مشتریان</div>
                  <div class="count">{{items.n_customers}}</div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="/CustomerCar/listReport" class="btn btn-square btn-sm btn-warning">
                  <i class="fa fa-cars"></i>
                  <div>تعداد خودروها</div>
                  <div class="count">{{items.n_car}}</div>
                </router-link>
              </ion-col>

              <ion-col size="6">
                <router-link to="/order/list?st=2" class="btn btn-square btn-sm btn-success">
                  <i class="fa fa-bags-shopping"></i>
                  <div> پرداخت شده</div>
                  <div >تعداد :  {{items.paid_order_count}}</div>
                  <div >مبلغ :
                    <Money :number="items.paid_order_amount"></Money>
                  </div>
                </router-link>
              </ion-col>

              <ion-col size="6">
                <router-link to="/order/list?st=3" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-bags-shopping"></i>
                  <div>مانده بدهی</div>
                  <div >تعداد : {{items.unpaid_order_count}}</div>
                  <div >مبلغ :
                    <Money :number="items.unpaid_order_amount"></Money>
                  </div>
                </router-link>
              </ion-col>

              <ion-col size="6">
                <router-link to="/order/list" class="btn btn-square btn-sm btn-danger">
                  <i class="fa fa-bags-shopping"></i>
                  <div>کل سفارشات</div>
                  <div >تعداد : {{items.total_order_count}}</div>
                  <div >مبلغ :
                    <Money :number="items.total_order_amount"></Money>
                    </div>
                </router-link>
              </ion-col>

              <ion-col size="6">
                <router-link to="/OrderOil/Report" class="btn btn-square btn-sm btn-success">
                  <i class="fa fa-oil-can"></i>
                  <div>روغن سوخته</div>
                  <div class="count">{{items.oil}}</div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="totalIncomeReport" class="btn btn-square btn-sm btn-warning">
                  <i class="fa fa-coins"></i>
                  <div>درآمد کل</div>
                  <div class="count"><Money :number="items.total_income"></Money></div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="/Report/user" class="btn btn-square btn-sm btn-danger">
                  <i class="fa fa-users-cog"></i>
                  <div>گزارش مشتریان</div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="/Report/admin" class="btn btn-square btn-sm btn-danger">
                  <i class="fa fa-users-cog"></i>
                  <div>گزارش کاربران</div>
                </router-link>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <div v-if="error" class="alert alert-danger">
          {{error}}
        </div>
      </div>

    </ion-card-content>
  </master-layout>
  </ion-page>
</template>


<script>

import MainPageItem from '/src/components/MainPageItem'
import Money from '/src/components/Money'
import {
  IonCardContent, IonGrid, IonCol, IonRow,IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";

export default {
  components: {
    IonCardContent, IonGrid, IonCol, IonRow,IonPage , MainPageItem,Money
  },
  data(){
    return{
      pageLoaded : false,
      error : false,
      items : false,
    }
  },async created()
  {
    const result = await this.getReportItems();
    if (result)
    {
      if (result.ok)
      {
        this.pageLoaded = true;
        this.items = result.items;
      }
      else
      {
        this.customerLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.pageLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  methods: {
    ...mapActions("report", {
      getReportItems: 'getReportItems',
    }),
  },
};
</script>

<style scoped>
.btn-square {
  width: 100%;
  display: block;
  text-align: center;
  height: 150px !important;
}
.count {
  font-size: 18px;
  font-weight: 900;
}
</style>